"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "30", height: "24", viewBox: "0 0 30 24", className: "Icon toolbar-image-preview-on", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("path", { fill: "#D9D9D9", d: "M1 1h28v22H1z" }),
            _react2.default.createElement("path", { fill: "#4C4C4C", d: "M10.5 10L20 23H1z" }),
            _react2.default.createElement("path", { fill: "#4C4C4C", d: "M23 16l6 7H17z" }),
            _react2.default.createElement("path", { d: "M22.5 10a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z", fill: "#FFF" }),
            _react2.default.createElement("path", { stroke: "#000", d: "M1 1h28v22H1z", strokeWidth: "2" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/small/jsx/toolbar-image-preview-on.js
// module id = 1883
// module chunks = 0